const helpCenterUrl = 'https://support.oneflow.com/';

export const getHelpCenterBaseUrl = () => helpCenterUrl;
